interface SimilarMovementCellDelegate
{
    similarMovementCellDidToggle(cell:SimilarMovementCell, movement:BankMovement, on:boolean): void;
}

class SimilarMovementCell extends UITableViewCell
{
    delegate:SimilarMovementCellDelegate = null;

    private checkButton:MUICheckButton = null;
    private dateLabel:MUILabel = null;
    private conceptLabel:MUILabel = null;
    private amountLabel:MUILabel = null;

    private _movement:BankMovement = null;

    awakeFromHTML(){
        this.checkButton = MUIOutlet(this, "check-cb", "MUICheckButton");
        this.checkButton.setOnChangeValue(this, function(this:SimilarMovementCell, control:MUICheckButton, value:boolean){
            if (this.delegate != null) this.delegate.similarMovementCellDidToggle(this, this._movement, value);
        });

        this.dateLabel = MUIOutlet(this, "date-lbl", "MUILabel");
        this.conceptLabel = MUIOutlet(this, "concept-lbl", "MUILabel");
        this.amountLabel = MUIOutlet(this, "amount-lbl", "MUILabel");

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    setItem(movement:BankMovement, selected:boolean){
        this._movement = movement;

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        this.checkButton.on = selected;
        this.dateLabel.text = ad.dateFormatter.stringFromDate(movement.date);
        this.conceptLabel.text = movement.concept;
        this.amountLabel.text = ad.currencyFormatter.stringFromNumber(movement.amount);
    }
}

class SimilarMovementsViewController extends MUIViewController implements SimilarMovementCellDelegate
{
    static newInstance() : SimilarMovementsViewController {
        let vc = new SimilarMovementsViewController("similar-movements-view");
        vc.initWithResource("layout/bankaccount/SimilarMovementsView.html");
        return vc;
    }

    account:AnalyticAccount = null;
    completionBlock:any = null;

    get preferredContentSize(){ return new MIOSize(900, 700); }

    private closeButton:MUIButton = null;
    private assignButton:MUIButton = null;
    private accountLabel:MUILabel = null;
    private tableView:UITableView = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.closeButton = MUIOutlet(this, "close-btn", "MUIButton");
        this.closeButton.setAction(this, function(this:SimilarMovementsViewController){
            this.dismissViewController(true);
        });

        this.assignButton = MUIOutlet(this, "assign-btn", "MUIButton");
        this.assignButton.setAction(this, function(this:SimilarMovementsViewController){
            let selected:BankMovement[] = [];
            for (let index = 0; index < this._movements.length; index++){
                if (this.selectedIDs[this._movements[index].identifier] == true) selected.push(this._movements[index]);
            }
            this.dismissViewController(true);
            if (this.completionBlock != null) this.completionBlock(selected);
        });

        this.accountLabel = MUIOutlet(this, "account-lbl", "MUILabel");

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    private _movements:BankMovement[] = [];
    private selectedIDs = {};
    set movements(items:BankMovement[]){
        this._movements = items;
        this.selectedIDs = {};
        for (let index = 0; index < items.length; index++) this.selectedIDs[items[index].identifier] = true;
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);
        this.accountLabel.text = this.account?.title;
        this.tableView.reloadData();
    }

    numberOfSections(tableView:UITableView){ return 1; }

    numberOfRowsInSection(tableView:UITableView, section:number){ return this._movements.length; }

    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let cell = tableView.dequeueReusableCellWithIdentifier("SimilarMovementCell") as SimilarMovementCell;
        let mv = this._movements[indexPath.row];
        cell.setItem(mv, this.selectedIDs[mv.identifier] == true);
        cell.delegate = this;
        return cell;
    }

    similarMovementCellDidToggle(cell:SimilarMovementCell, movement:BankMovement, on:boolean){
        this.selectedIDs[movement.identifier] = on;
    }
}
